const BASE = 'tn-event-listing-view';

const EventListingViewClasses = {
  BASE,
  LOADING_MODIFIER: `${BASE}--loading`,
  CONTROLS_CONTAINER: `${BASE}__controls-container`,
  RESULTS_CONTAINER: `${BASE}__results-container`,
  RESULTS_HEADING: `${BASE}__results-heading`,
};

export default EventListingViewClasses;
